import script from "./CatalogProductList.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogProductList.vue?vue&type=script&setup=true&lang=js"

import "./CatalogProductList.vue?vue&type=style&index=0&id=9a2813a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a2813a4"]])

export default __exports__